import {
  ADD_PENDING_CALL,
  REMOVE_PENDING_CALL,
} from "features/application/loader/redux/types";

export const addPendingCallAction = () => ({ type: ADD_PENDING_CALL });

export const removePendingCallAction = () => ({ type: REMOVE_PENDING_CALL });
